// extracted by mini-css-extract-plugin
module.exports = {"secondary-icon":"secondary-icon__5Ha3K","icon":"icon__crPgN"};